var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"title__wrapper"},[_c('h1',{staticClass:"title__heading",domProps:{"innerHTML":_vm._s(_vm.$props.title)}}),(_vm.$slots.default)?_c('div',{staticClass:"title__intro"},[_vm._t("default")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }